import Util from 'util/util'

export default class TeacherModel extends Backbone.Model {

    preinitialize() {
        this.constructor.type = 'teacher'
        this.constructor.pluralType = 'teachers'
    }

    last_name_first_name() {
        return Util.lastNameFirstName(this.get('first_name'), this.get('prefix'), this.get('sortable_last_name'))
    }

    first_name_last_name() {
        return Util.firstNameLastName(this.get('first_name'), this.get('prefix'), this.get('sortable_last_name'))
    }

    getLabel({displayFirstNameFirst = false} = {}) {
        const label = displayFirstNameFirst ? this.first_name_last_name() : this.last_name_first_name()
        return {
            label,
            title: label,
        }
    }

    getCrumblepathModel() {
        return new Backbone.Model({
            ...this.getLabel({displayFirstNameFirst: true}),
            level: 'students',
            path_id: this.get('id')
        });
    }

    /**
     * getAllCrumblepathModels
     *
     * This function will return an array of all the models for this
     * crumblepath
     *
     * @return {Array}      Array with all the models
     */
    getAllCrumblepathModels() {
        return [
            this.getGroupModel().getCrumblepathModel(),
            this.getCrumblepathModel()
        ]
    }

    getGroupModel() {
        // Return the group bound to this teacher
        return Backbone.Collection.groups.get(this.get('group_id'));
    }

}
